import React, { useRef, useImperativeHandle, forwardRef } from "react"

import Drawer from '../Drawer'

import { Toolbar } from '@material-ui/core'
import { StyledHeader } from "./styles"

import RoundButton from "../RoundButton"
import Dialog from "../Dialog"

const Header = (props, ref) => {
  const { help, download, nohome, cover, helpTitle, helpContent } = props
  const drawerref = useRef(Drawer)

  const openDrawer = async (key) => {
    if(!drawerref.current){
        return
    }

    await drawerref.current.openDrawer(key)
    drawerref.current.scrollList()
  }

  useImperativeHandle(ref, () => ({
    openRef: key => {
      openDrawer(key)
    }
  }))

  return (
    <StyledHeader cover={cover}>
      <Toolbar>
        <Drawer ref={drawerref}/>
        {
          nohome?
          <></>
          :
          <RoundButton tooltip="Início" to="/" type="home" margin={true}/>
        }       
        <div className="endbutton">
          {
            help?
            <>
              <Dialog help title={helpTitle} content={helpContent} />
              {console.log(helpContent)}
              </>
            :
              <></>
          }
          {
            download?
              <RoundButton tooltip="Versão pdf" type="download" margin/>            
            :
              <></>
          }
        </div>
      </Toolbar>
    </StyledHeader>
  )
}

export default forwardRef(Header)
